import { select, call, put } from 'redux-saga/effects';
import { selectNotificationVolume, setAudioDevices, setDefaultSpeaker, setDefaultMicrophone, setDefaultRingtone } from '../../../state/audioDevice/audioDeviceSlice';
import { showSnackbar } from '../../../state/snackbar/snackbarSlice';
import { setAudioOutputDevice, setRingtone, changeNotificationVolume } from '../../../utils/audioUtils';
import { getDefaultSpeaker, getDefaultMicrophone, getDefaultRingtone } from '../../../browser/storage';


export function* loadAudioDeviceSaga() {
    try {
        const defaultSpeaker = yield call(getDefaultSpeaker);
        const defaultMicrophone = yield call(getDefaultMicrophone);
        const defaultRingtone = yield call(getDefaultRingtone);
        let devices = yield call([navigator.mediaDevices, 'enumerateDevices']);
        console.log('[VERBOSE] Devices', devices)
        try {
            yield call([navigator.mediaDevices, 'getUserMedia'], { audio: true });
            devices = yield call([navigator.mediaDevices, 'enumerateDevices']);
        } catch (micError) {
            console.warn('No microphone access:', micError.message);
        }
        const formattedDevices = {
            speakers: devices.filter(d => d.kind === 'audiooutput').map(d => ({
                deviceId: d.deviceId,
                label: d.label || 'Default Speaker'
            })),
            microphones: devices.filter(d => d.kind === 'audioinput').map(d => ({
                deviceId: d.deviceId,
                label: d.label || 'Default Microphone'
            }))
        };
        console.log("[VERBOSE] These are the formattedDevices", formattedDevices)

        // Add notifications for missing devices
        if (formattedDevices.microphones.length === 0) {
            yield put(showSnackbar({
                message: 'No microphone detected. Please connect a microphone.',
                severity: 'warning'
            }));
        }
        if (formattedDevices.speakers.length === 0) {
            yield put(showSnackbar({
                message: 'No speakers detected. Please connect speakers or headphones.',
                severity: 'warning'
            }));
        }


        yield put(setAudioDevices(formattedDevices));

        // Only set devices if we have them
        if (formattedDevices.speakers.length > 0) {
            const speakerId = defaultSpeaker || 'default';
            yield put(setDefaultSpeaker({ speaker: speakerId }));
            if (speakerId) {
                try {
                    yield call(setAudioOutputDevice, speakerId);
                } catch (speakerError) {
                    console.error('Error setting output device:', speakerError);
                    yield put(showSnackbar({
                        message: 'Failed to set output device. Please check your audio settings.',
                        severity: 'error'
                    }));
                }
            }
        } else {
            // Explicitly set to empty string when no speakers
            yield put(setDefaultSpeaker({ speaker: '' }));

        }
        if (formattedDevices.microphones.length > 0) {
            const microphoneId = defaultMicrophone || 'default';
            yield put(setDefaultMicrophone({ microphone: microphoneId }));
        } else {
            // Explicitly set to empty string when no microphones
            yield put(setDefaultMicrophone({ microphone: '' }));
        }

        if (defaultRingtone) {
            yield call(setRingtone, defaultRingtone);
            yield put(setDefaultRingtone(defaultRingtone));
        }

        // Initialize notification volume for all audio elements (ringTone, ringbackTone, dtmfTone, previewTone)
        const notificationVolume = yield select((state) => state.audioDevices.notificationVolume);
        yield call(changeNotificationVolume, notificationVolume);

    } catch (error) {
        console.error('Error loading audio devices:', error);
        // Initialize with empty device lists rather than failing completely
        yield put(setAudioDevices({ speakers: [], microphones: [] }));
        yield put(showSnackbar({
            message: 'Failed to load audio devices. Please check your system settings.',
            severity: 'error'
        }));
    }

}